import React, { useEffect, useRef, useState } from "react"
import clsx from "clsx"

import Helmet from "@helpers/Helmet"
import { container } from "@components/wrapper"
import { CourseDetail } from "@interfaces/course/course-detail"
import {
  CourseBanner,
  CourseDescription,
  CourseInfoList,
  CourseMaterialList,
  CourseReview,
  CourseSidebar,
  CourseTutor,
  RelatedCourse,
} from "./components"
import { Header } from "@components/header"
import { HariseninFooter } from "@components/harisenin"
import { useScreenSize } from "@lib/hooks"
// import { useAnalytics } from "@lib/context/AnalyticsContext"

export interface CourseDetailPageProps {
  data: CourseDetail
  schema: any
}

const CourseDetailPage: React.FC<CourseDetailPageProps> = ({ data, schema }) => {
  const [isTransparent, setIsTransparent] = useState(true)
  const [isSidebarChanged, setIsSidebarChanged] = useState(false)
  const [isFixed, setIsFixed] = useState(true)
  const [screenHeight, setScreenHeight] = useState(0)

  const { screenWidth } = useScreenSize()
  // const { analytics } = useAnalytics()

  const initialized = useRef(false)

  useEffect(() => {
    setScreenHeight(window.innerHeight)
    window.addEventListener("scroll", trackScrolling)
    window.addEventListener("resize", handleViewPort)

    if (!initialized.current) {
      initialized.current = true

      // analytics.track("Product Viewed", {
      //   products: [
      //     {
      //       product_id: data.course_sku,
      //       name: data.course_name,
      //       affiliation: "PT. Karya Kaya Bahagia",
      //       coupon: "",
      //       discount: 0,
      //       currency: "IDR",
      //       brand: "HSL",
      //       category: data.course_categories,
      //       variant: "",
      //       price: data.course_price,
      //       quantity: 1,
      //       position: 0,
      //       item_list_name: data.course_name,
      //       item_list_id: data.id,
      //     },
      //   ],
      //   currency: "IDR",
      //   value: data.course_price,
      // })
    }

    return () => {
      window.removeEventListener("scroll", trackScrolling)
      window.removeEventListener("resize", handleViewPort)
    }
  }, [screenHeight])

  const handleViewPort = () => {
    setScreenHeight(window.innerHeight)
  }

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("header")
    const wrappedDesc = document.getElementById("desc-id")
    const wrappedRelated = document.getElementById("related-class")

    if (!wrappedElement) {
      return
    } else {
      const isBtm = wrappedElement.getBoundingClientRect().top < 60

      if (isBtm) {
        setIsTransparent(false)
      } else {
        setIsTransparent(true)
      }
    }

    if (!wrappedDesc) {
      return
    } else {
      const eleTop = wrappedDesc.getBoundingClientRect().top

      if (eleTop < 110) {
        setIsSidebarChanged(true)
      } else {
        setIsSidebarChanged(false)
      }
    }

    if (!wrappedRelated) {
      return
    } else {
      const eleTop = wrappedRelated.getBoundingClientRect().top

      if (eleTop < screenHeight) {
        setIsFixed(false)
      } else {
        setIsFixed(true)
      }
    }
  }

  return (
    <>
      <Helmet
        title={data.course_meta_title}
        isIndexed
        description={data.course_meta_description}
        schemaMarkup={{
          ...schema,
          uploadDate: new Date(schema.uploadDate).toUTCString(),
        }}
      />
      <Header transparent={isTransparent} isNotSticky />

      <main className="relative">
        <section className="relative">
          <CourseBanner screenWidth={screenWidth} courseDetail={data} />

          <CourseSidebar
            isSidebarChanged={isSidebarChanged}
            isFixed={isFixed}
            screenWidth={screenWidth}
            classDetail={data}
          />

          <section className={container}>
            <div
              className={clsx(
                "sm:w-[calc(75%-40px)] grid sm:gap-[60px] sm:pt-10 sm:pr-10 pb-12",
                "pt-[30px] gap-[30px]"
              )}
            >
              <CourseDescription description={data.course_description} />
              <CourseInfoList data={data} />
              <CourseTutor tutors={data.course_teachers} />
              <CourseMaterialList
                data={data.course_material}
                duration={data?.course_study_period[0] ?? ""}
              />
              <CourseReview reviewInfo={data.review_summaries} courseId={data.id} />
            </div>
          </section>
        </section>

        <RelatedCourse screenWidth={screenWidth} data={data.other_courses} />
      </main>

      <HariseninFooter />
    </>
  )
}

export default CourseDetailPage
